import { create } from "zustand"
import type { TokenUser } from "@/types/api"

interface AuthState {
  accessToken: string | null
  refreshToken: string | null
  userId: string | null
  user: TokenUser | null
  isAuthenticated: boolean
  setTokens: (access: string, refresh: string) => void
  setUserId: (id: string) => void
  setUser: (user: TokenUser) => void
  logout: () => void
}

function loadUser(): TokenUser | null {
  try {
    const raw = localStorage.getItem("user")
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}

export const useAuthStore = create<AuthState>((set) => ({
  accessToken: localStorage.getItem("access_token"),
  refreshToken: localStorage.getItem("refresh_token"),
  userId: localStorage.getItem("user_id"),
  user: loadUser(),
  isAuthenticated: !!localStorage.getItem("access_token"),

  setTokens: (access, refresh) => {
    localStorage.setItem("access_token", access)
    localStorage.setItem("refresh_token", refresh)
    set({ accessToken: access, refreshToken: refresh, isAuthenticated: true })
  },

  setUserId: (id) => {
    localStorage.setItem("user_id", id)
    set({ userId: id })
  },

  setUser: (user) => {
    localStorage.setItem("user", JSON.stringify(user))
    set({ user })
  },

  logout: () => {
    localStorage.removeItem("access_token")
    localStorage.removeItem("refresh_token")
    localStorage.removeItem("user_id")
    localStorage.removeItem("user")
    set({
      accessToken: null,
      refreshToken: null,
      userId: null,
      user: null,
      isAuthenticated: false,
    })
  },
}))
